module.exports = __webpack_public_path__ + "img/5-rectangle-6-copy-10@2x.193eb5b6.png";